<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrOdenekTalep from "@/models/StrOdenekTalep";

import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import Treeselect from "@riophae/vue-treeselect";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [Api, Sabit, StrOdenekTalep],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      Strperformanshedefiid: "",
      Strtabdetfaaliyetid: "",
      guncele: "Add",
      file: "",
      aktif_arama: false,
      AdminRoleKontrol: false,
    };
  },
  components: {
    Loader,
    forminput,
    formcombobox,
    BirimSecimi,
    // formtreeselect,
    Treeselect
  },
  watch: {
    Id() {
      if (this.AddEdit == "Add") {
        this.aktif_arama = true;
      } else {
        this.aktif_arama = false;
        this.liste_kontrol();
      }
      this.FormData = this.Id;
      setTimeout(() => {
        this.aktif_arama = true;
      }, 200);
   },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.FormData.Fileurl != "" || this.FormData.Aciklama != "") { 
        if (this.AddEdit == "Add") {
          this.Post("StrOdenekTalep", this.FormData).then((res) => {
            if (res) {
              this.$bvModal.hide("StrOdenekTalep");
              this.FormData.Id = res.Data;
              this.$emit("TableUpdate");
            }
          });
        } else {
          this.Update("StrOdenekTalep", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.$bvModal.hide("StrOdenekTalep");
            }
          });
        }
       }else{
          this.$toast.error('Açıklama ya da dosya ekleyiniz.');
        }
      }
    },
    FileUpload() {
      var file = this.$refs.file.files[0];
      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (
        uzanti == "png" ||
        uzanti == "jpeg" ||
        uzanti == "jpg" ||
        uzanti == "doc" ||
        uzanti == "xml" ||
        uzanti == "pdf" ||
        uzanti == "xlsx"
      ) {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Str",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {
            this.FormData.Fileurl = res.Data.filename;
            this.$toast.success(this.$t("ToasMessage.FilePozitif"));
          } else {
            this.$toast.error(this.$t("ToasMessage.FileNegatif"));
          }
        });
      } else {
        this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
      }
    },
    Get() {
      this.$emit("TableUpdate");
      this.currentDate = new Date(); 
    },

    loadOptions({ action, callback }) {
      this.options = [];
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

          this.options = this.hesapkodlari;

          callback(null, this.options)
        })
      }
    },

    liste_yukle(veri) {
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };

      if (veri.length >= 1) {

        this.hesapkodlari = [];

        let Filter = "";
        if (veri[0] == "0" && veri[2] == ".") {
          Filter = "&Basamak=4&KodForLike=" + veri;
        } else {

          Filter = "&Basamak=4&Aciklama=" + veri;
        }

        this.ActionsFilterGet({ Service: "StrHesapKodlari", Page: Page, Filter: Filter }).then(res => {
          for (var i = 0; i < res.Data.length; i++) {
            this.hesapkodlari.push({ id: res.Data[i].Id, label: res.Data[i].Kod + " - " + res.Data[i].Aciklama })
          }
        });

      }

    },

    liste_kontrol() {

      if (this.AddEdit == "Edit") {
        this.hesapkodlari = [];
        this.options = [];

        this.hesapkodlari.push({ "id": this.Id.Hesapkodlariid, "label": this.Id.HesapKodAciklama })

        this.options = this.hesapkodlari;
      }
    },




  },
  created() {
    let YetkiSorgu = this.UserRolles.filter((item) =>
      item.includes("SuperAdmin") || item.includes("StrAdmin")
    );
    if (YetkiSorgu.length != 0) this.AdminRoleKontrol = true;

  }
};
</script>
<template>
  <Loader>
    <b-modal id="StrOdenekTalep" size="lg" :title="this.AddEdit == 'Edit'
        ? $t('StrOdenekTalep.AddEdit.FormTitleEdit')
        : $t('StrOdenekTalep.AddEdit.FormTitleAdd')
      " title-class="font-18" hide-footer>
    
      <Form @submit.prevent="onSubmit">

        <div class="row">
          <div class="col-md-12">


            <BirimSecimi :title="FormDataType.Birimid.FieldTitle" :sutun="'0'" :title_class="'mb-3'"
              :selected="FormData.Birimid" :v="$v.FormData.Birimid" :YetkiKontrol="1" :multiple="false" :BirimTipId="null"
              @Secilmis_Idler="FormData.Birimid = $event" />

          </div>

        </div>

        <div class="row">
          <div class="col-md-6">

            <formcombobox :FormDataType="FormDataType.Yil" :Value="FormData.Yil" :v="$v.FormData.Yil"
              @input="(FormData.Yil = $event)" />


          </div>
          <div class="col-md-6">
            <formcombobox :FormDataType="FormDataType.Ay" :Value="FormData.Ay" :v="$v.FormData.Ay"
              @input="(FormData.Ay = $event)" />

          </div>

        </div>

        <div class="row">
          <div class="col-md-12">
            <b-form-group class="mb-3" id="example text" label="Hesap Kodu" label-for="text">
              <treeselect name="'Hesapkodid'" id="'Hesapkodid'" @search-change="liste_yukle($event)" :async="aktif_arama"
                :load-options="loadOptions" :options="FormDataType.Hesapkodid.ComboDataArray" :multiple="false"
                :cacheOptions="false" searchPromptText="Aramak için yazın..." placeholder="Seçiniz..."
                v-model="FormData.Hesapkodid" />
              <treeselect-value :value="FormData.Hesapkodid" />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <forminput :FormDataType="FormDataType.Serbestodenek" :Value="FormData.Serbestodenek"
              :v="$v.FormData.Serbestodenek" @input="FormData.Serbestodenek = $event" :min="0" :step="0.01" />
          </div>
          <div class="col-md-4">
            <forminput :FormDataType="FormDataType.Blokeodenek" :Value="FormData.Blokeodenek" :v="$v.FormData.Blokeodenek"
              @input="FormData.Blokeodenek = $event" :min="0" :step="0.01" />
          </div>
          <div class="col-md-4">
            <forminput :FormDataType="FormDataType.Harcananodenek" :Value="FormData.Harcananodenek"
              :v="$v.FormData.Harcananodenek" @input="FormData.Harcananodenek = $event" :min="0" :step="0.01" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <forminput :FormDataType="FormDataType.Talepedilenodenek" :Value="FormData.Talepedilenodenek"
              :v="$v.FormData.Talepedilenodenek" @input="FormData.Talepedilenodenek = $event" :min="0" :step="100.0" />
          </div>
          <div class="col-md-6" v-if="AdminRoleKontrol == true">
            <forminput :FormDataType="FormDataType.Karsilananodenek" :Value="FormData.Karsilananodenek"
              :v="$v.FormData.Karsilananodenek" @input="FormData.Karsilananodenek = $event" :min="0" :step="0.01" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-10">
            <label for="formFile" class="form-label">Dosya Ekle</label>
            <b-form-group class="mb-3 mt-">
              <input class="form-control" ref="file" type="file" v-on:change="FileUpload($event)" id="FormData.Fileurl"
                accept=".pdf, .doc, .png" />
            </b-form-group>
          </div>
          <div class="col-md-2" v-if="this.FormData.Fileurl">
            <div class="row">
              <label for="formFile" class="form-label text-center">Mevcut Dosya</label>
            </div>
            <div class="row text-center">
              <a v-if="FormData.Fileurl" :href="this.$config.FILES_URL +
                'str/' +
                FormData.Fileurl
                " target="_blanl">
                <i class="fas fa-eye" v-tooltip="'Dosya Görüntüle'"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <forminput :FormDataType="FormDataType.Aciklama" :Value="FormData.Aciklama" :v="$v.FormData.Aciklama"
              @input="FormData.Aciklama = $event" />
          </div>
        </div>
        <div class="row" v-if="AdminRoleKontrol == true">
          <div class="col-md-12">
            <forminput :FormDataType="FormDataType.Onayaciklama" :Value="FormData.Onayaciklama"
              :v="$v.FormData.Onayaciklama" @input="FormData.Onayaciklama = $event" />
          </div>
        </div>
        <button class="btn btn-primary" type="submit">
          {{ $t("StrOdenekTalep.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
